import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { TotalSupplierType } from "../types"

type ExpencesActivitiesType = {
  year_month: string
  location_id: string
}

export function useTotalSupplierPurchase(params: ExpencesActivitiesType) {
  const api = useApi()
  const [data, setData] = useState<TotalSupplierType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: ExpencesActivitiesType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/dashboard_purchase/payment_to_supplier", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: TotalSupplierType }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/dashboard_purchase/payment_to_supplier", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: TotalSupplierType }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}